import { c as _c } from "react/compiler-runtime";
import { passkeyClient } from "@better-auth/passkey/client";
import { createAuthClient } from "better-auth/react";
import { useMemo } from "react";
import { useAppConfig } from "./config";

// React hook to get the auth client
export function useAuthClient() {
  const $ = _c(2);
  const config = useAppConfig();
  const authBaseUrl = config.authUrl ? config.authUrl : config.apiUrl;
  const t0 = authBaseUrl + "/auth";
  let t1;
  if ($[0] !== t0) {
    t1 = createAuthClient({
      baseURL: t0,
      plugins: [passkeyClient()]
    });
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}

// React hook for auth methods
export function useAuth() {
  const $ = _c(6);
  const authClient = useAuthClient();
  let t0;
  if ($[0] !== authClient.getSession || $[1] !== authClient.signIn || $[2] !== authClient.signOut || $[3] !== authClient.signUp || $[4] !== authClient.useSession) {
    t0 = {
      signIn: authClient.signIn,
      signUp: authClient.signUp,
      signOut: authClient.signOut,
      useSession: authClient.useSession,
      getSession: authClient.getSession
    };
    $[0] = authClient.getSession;
    $[1] = authClient.signIn;
    $[2] = authClient.signOut;
    $[3] = authClient.signUp;
    $[4] = authClient.useSession;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
}